// extracted by mini-css-extract-plugin
export var alt = "BrandsFilter-module--alt--13b96";
export var desktopOnly = "BrandsFilter-module--desktopOnly--df2f7";
export var filterDropdown = "BrandsFilter-module--filterDropdown--e1c36";
export var main = "BrandsFilter-module--main--f7685";
export var mobileOnly = "BrandsFilter-module--mobileOnly--f4f2d";
export var textLeft = "BrandsFilter-module--textLeft--9d5c6";
export var visuallyHidden = "BrandsFilter-module--visuallyHidden--fcaaf";